import { useQuery } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";

import { get } from "api";
import {
  AdvisorIdentity,
  NiceToMeetYouAdvisor,
} from "modules/personalisation/components/NiceToMeetYouAdvisor";
import { ImproveConcernsContainer_PATH } from "modules/personalisation/containers/ImproveConcernsContainer";
import { PersonalisationAdvisorBenefitsContainer_PATH } from "modules/personalisation/containers/PersonalisationAdvisorBenefitsContainer";
import { usePersonalisationData } from "modules/personalisation/context/PersonalisationDataContext";

export const MeetYourAIAdvisorContainer_PATH =
  "/personalise/meet-your-advisor" as const;

export const MeetYourAIAdvisorContainer = () => {
  const navigate = useNavigate();
  const { advisor } = usePersonalisationData();

  const { data: user } = useQuery({
    queryKey: ["/user"],
    queryFn: () => get("/user"),
    staleTime: 1000 * 60 * 2, // 2 minutes cache
  });

  const identity: AdvisorIdentity =
    advisor.state === "answered"
      ? {
          name: advisor.value.id as "aria" | "adonis",
        }
      : {
          name: "adonis",
        };

  return (
    <NiceToMeetYouAdvisor
      identity={identity}
      platformName={user?.platform?.name || ""}
      userName={user?.firstName || ""}
      onBack={() => navigate(PersonalisationAdvisorBenefitsContainer_PATH)}
      onBegin={() => navigate(ImproveConcernsContainer_PATH)}
    />
  );
};
